<template>
  <div class="container">
    <div class="row">
      <div class="col-3 col-md-2">
        <div id="list-year" class="list-group list-group-flush text-center">
          <a
            v-for="(year, index) in years"
            :key="index"
            href="#"
            class="list-group-item list-group-item-action"
            :class="{ active: year.year == onYear }"
            @click="clickYear(year.year, $event)"
            >{{ year.year }}</a
          >
        </div>
      </div>
      <div class="col-9 col-md-10" id="map"></div>
    </div>
  </div>
</template>

<script>
import { apiYear, apiList } from '@/api/index'

export default {
  data() {
    return {
      years: [],
      items: [],
      pickers: [],
      onYear: 0,
      map: null,
      infowindow: null,
      markers: [],
      lat: 24.827084,
      lng: 121.010742,
      points: {},
    }
  },
  mounted() {
    this.initMap()
    this.getYear()
  },
  watch: {
    center() {
      this.resetCenter()
      this.setMarker()
    },
  },
  methods: {
    async getYear() {
      await apiYear().then(response => {
        this.years = response.data
        this.onYear = this.years[0].year
      })
      this.getList()
    },
    async getList() {
      let loader = this.$loading.show()
      await apiList().then(response => {
        this.items = response.data.items
        this.pickYear(this.onYear)
        setTimeout(() => {
          loader.hide()
        }, 800)
      })
    },
    pickYear(y) {
      this.pickers = this.items.filter(s => s.year == y)
      this.setMarker()
    },
    clickYear(y, event) {
      this.$(event.target).addClass('active').siblings().removeClass('active')
      this.pickYear(y)
      event.preventDefault()
    },
    initMap() {
      const google = window.google
      this.map = new google.maps.Map(document.getElementById('map'), {
        center: { lat: this.lat, lng: this.lng },
        zoom: 11,
        disableDefaultUI: true,
        zoomControl: true,
        streetViewControl: false,
        panControl: true,
        scaleControl: true,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
      })
    },
    resetCenter() {
      this.map.panTo({ lat: this.center.lat, lng: this.center.lng })
    },
    clearMarkers() {
      this.markers.forEach(marker => marker.setMap(null))
      this.markers = []
    },
    setMarker() {
      const google = window.google
      this.clearMarkers()
      var go = true
      this.pickers.forEach(location => {
        const marker = new google.maps.Marker({
          // 設定為該餐廳的座標
          position: {
            lat: parseFloat(location.latitude),
            lng: parseFloat(location.longitude),
          },
          map: this.map,
        })
        this.markers.push(marker)
        // 建立訊息視窗
        const infowindow = new google.maps.InfoWindow({
          content: `
          <div>
            <a href="/storymap/c-${location.code}" target="_target"><img
                src="${location.imgFolder + location.imgName}"
                class="card-img-top img-fluid"
            /></a>
            <p class="h5">
              <a href="/storymap/c-${location.code}" target="_target">${
            location.subject
          }</a>
            </p>
            <p class="card-text">
              <i class="fa fa-location-arrow" aria-hidden="true"></i>
              ${location.location}
            </p>
          </div>
        `,
          maxWidth: 200,
        })
        marker.addListener('click', () => {
          if (this.infowindow) this.infowindow.close()
          infowindow.open(this.map, marker)
          this.map.panTo(new google.maps.LatLng(marker.getPosition().lat(), marker.getPosition().lng()))
          this.infowindow = infowindow
        })
        if (go)
        {
          this.map.panTo(new google.maps.LatLng(parseFloat(location.latitude), parseFloat(location.longitude)))
          go = false
        }
      })
    },
  },
}
</script>
